import { render } from "./DragDropUpload.vue?vue&type=template&id=45ee919a&scoped=true"
import script from "./DragDropUpload.vue?vue&type=script&lang=js"
export * from "./DragDropUpload.vue?vue&type=script&lang=js"

import "./DragDropUpload.vue?vue&type=style&index=0&id=45ee919a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ee919a"]])

export default __exports__